import styled from 'styled-components';
import ResetSolid from '@simplywallst/ui-core/icons/ResetSolid';
import SearchSolid from '@simplywallst/ui-core/icons/SearchSolid';
interface SearchWrapperProps {
  isActive?: boolean;
}

export const SearchWrapper = styled('div')<SearchWrapperProps>`
  width: 100%;
  position: relative;
  z-index: 1;
  background: ${({ isActive }) =>
    isActive === true ? `white` : `transparent`};
`;

interface SearchDropProps {
  width?: number;
}

export const SearchDrop = styled('div')<SearchDropProps>`
  width: ${({ width }) => (width ? width : 400)}px;
  overflow: hidden;
`;

type ScrollPaneProps = {
  light?: boolean;
};
export const ScrollPane = styled('div')<ScrollPaneProps>`
  top: ${({ theme }) => theme.x1spacePx / 2}px;
  left: 0;
  position: absolute;
  background-color: ${({ theme }) => theme.color.noir};
  border-radius: 4px;
  border: 1px solid
    ${({ theme, light }) =>
      light ? theme.color.lightGray : theme.color.whiteRGBA(0.1)};
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 554px;
  box-shadow: ${({ theme }) =>
    `0px 4px 10px 0px ${theme.color.blackRGBA(0.3)}`};
`;

export const SearchIcon = styled(SearchSolid)`
  > path {
    fill: ${({ theme }) => theme.color.brand01};
  }
`;

export const ResetIcon = styled(ResetSolid)`
  opacity: 0.5;
  > path {
    fill: ${({ theme }) => theme.color.white};
  }
`;
